<template>
  <v-container fluid>
    <page-header @menuClick="chooseMenu" :menuItems="menuItems">
      <v-breadcrumbs>
        <v-breadcrumbs-item :to="{ name: 'Teachers' }"
          >Teachers</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true">
          {{ teacher ? `${teacher.firstName} ${teacher.lastName}` : "N/A" }}
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </page-header>

    <v-card class="mt-5" v-if="teacher">
      <v-tabs show-arrows v-model="tab" icons-and-text>
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-info">
          Info
          <v-icon>mdi-account</v-icon>
        </v-tab>
        <v-tab href="#tab-attendance">
          Attendance
          <v-icon>mdi-human-handsup</v-icon>
        </v-tab>
        <v-tab href="#tab-availability">
          Availability
          <v-icon>mdi-clock</v-icon>
        </v-tab>
        <v-tab href="#tab-calendar">
          Calendar
          <v-icon>mdi-calendar</v-icon>
        </v-tab>

        <v-tabs-items class="ma-2" v-model="tab">
          <v-tab-item value="tab-info">
            <v-row class="mt-2">
              <v-col :lg="canViewRate ? 6 : 12" md="12">
                <div class="text-subtitle-2 d-flex justify-space-between">
                  <div class="pa-2">
                    Profile ({{
                      teacher.registered ? "Registered" : "Not Registered"
                    }})

                    <v-btn
                      small
                      class="mx-2"
                      @click="registerTeacher"
                      v-if="!teacher.registered"
                      hint="This will register the teacher and send a temporary password to teacher's email"
                      >Register Teacher</v-btn
                    >
                  </div>
                  <v-menu :close-on-content-click="false" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        dark
                        rounded
                        :color="teacher.color"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-palette</v-icon>
                      </v-btn>
                    </template>
                    <v-color-picker
                      @update:color="pickedColor"
                      :value="teacher.color"
                      hide-inputs
                      show-swatches
                    />
                  </v-menu>
                </div>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>Name</td>
                        <td>{{ teacher.firstName }} {{ teacher.lastName }}</td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>{{ teacher.email }}</td>
                      </tr>
                      <tr>
                        <td>Phone</td>
                        <td>
                          <the-mask
                            mask="+1(###) ###-####"
                            v-model="teacher.phone"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Main Location</td>
                        <td>{{ teacher.center ? teacher.center.name:'N/A' }}</td>
                      </tr>
                      <tr>
                        <td>About</td>
                        <td>
                          <div style="white-space: pre-line;" class="my-2">
                            {{ teacher.about }}
                          </div>
                        </td>
                      </tr>
                      <tr v-if="teacher.accessCode">
                        <td>Classroom Access Code</td>
                        <td style="white-space: pre-line;">
                          {{ teacher.accessCode }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col v-if="canViewRate" lg="6" md="12">
                <v-subheader>Rate</v-subheader>
                <v-simple-table
                  v-if="teacher.hourlyRates && teacher.hourlyRates.length > 0"
                >
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="rate in teacher.hourlyRates" :key="rate.id">
                        <td>
                          {{ rate.name }}
                          <v-tooltip v-if="rate.remark" left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" icon>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ rate.remark }}</span>
                          </v-tooltip>
                        </td>
                        <td>{{ rate.hourlyRate | currency }}</td>
                        <td>{{ rate.startDate | formatDate }}</td>
                        <td>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-card
                              class="mx-auto"
                              max-width="400"
                              width="200"
                              tile
                            >
                              <v-list dense>
                                <v-list-item-group color="primary">
                                  <v-list-item @click="deleteRate(rate)">
                                    <v-list-item-icon class="mr-2">
                                      <v-icon>mdi-delete</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >Delete Rate</v-list-item-title
                                      >
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item
                                    :to="{
                                      name: 'TeacherRate',
                                      params: {
                                        teacherId: teacher.id,
                                        id: rate.id
                                      }
                                    }"
                                  >
                                    <v-list-item-icon class="mr-2">
                                      <v-icon>mdi-pencil</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >Edit Rate</v-list-item-title
                                      >
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                            </v-card>
                          </v-menu>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-list-item v-else>
                  <v-list-item-title> No pay rate defined</v-list-item-title>
                </v-list-item>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item value="tab-attendance">
            <teacher-attendance v-if="teacherLoaded" :teacher="teacher" />
          </v-tab-item>
          <v-tab-item value="tab-availability">
            <teacher-availabilities v-if="teacherLoaded" :teacher="teacher" />
          </v-tab-item>
          <v-tab-item value="tab-calendar">
            <teacher-calendar v-if="teacherLoaded" :teacher="teacher" />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>

    <v-dialog v-model="teacherDialog">
      <choose-teacher v-model="teacher" @selected="changeTeacher" />
    </v-dialog>

    <v-dialog v-model="resetPwdDialog">
      <reset-teacher-password v-model="teacher" />
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const ChooseTeacher = () => import("@/components/teacher/ChooseTeacher.vue");
const PageHeader = () => import("@/components/common/PageHeader.vue");
const TeacherAvailabilities = () =>
  import("@/components/teacher/TeacherAvailabilities.vue");
const TeacherCalendar = () =>
  import("@/components/teacher/TeacherCalendar.vue");
const TeacherAttendance = () =>
  import("@/components/teacher/TeacherAttendance.vue");
const ResetTeacherPassword = () =>
  import("@/components/teacher/ResetTeacherPassword.vue");

import moment from "moment";
import { TheMask } from "vue-the-mask";

export default {
  data() {
    return {
      teacher: {},
      teacherLoaded: false,
      teacherDialog: false,
      resetPwdDialog: false,
      tab: null
    };
  },
  filters: {
    formatDate(value) {
      return moment(value).format("ddd, MMM DD YYYY");
    }
  },
  computed: {
    ...mapGetters(["isAppLoading", "currentUser"]),
    canViewRate() {
      return this.currentUser.roles.includes("VIEWRATE");
    },
    canManageSchedule() {
      return this.currentUser.roles.includes("MANAGESCHEDULE");
    },
    menuItems() {
      let menu = [
        {
          id: "switch-teacher",
          text: "Switch Teacher",
          icon: "mdi-account-switch-outline"
        },
        {
          id: "edit-profile",
          text: "Edit Profile",
          icon: "mdi-account-outline",
          to: { name: "EditTeacher", params: { id: this.teacher.id } }
        },
        {
          id: "delete-teacher",
          text: "Delete Teacher",
          icon: "mdi-delete-outline"
        }
      ];

      if (this.teacher.registered) {
        menu.push({
          id: "reset-password",
          text: "Reset Password",
          icon: "mdi-lock-reset"
        });
      }

      if (this.canViewRate) {
        menu.push({
          id: "add-rate",
          text: "Add Rate",
          icon: "mdi-currency-usd"
        });
      }

      if (this.canManageSchedule) {
        menu.push({
          id: "add-timerecord",
          text: "Add Time Record",
          icon: "mdi-clock-outline"
        });
      }

      // if (this.canViewRate) {
      menu.push({
        id: "add-schedule",
        text: "Add Schedule",
        icon: "mdi-calendar-account-outline"
      });
      menu.push(
        {
          id: "add-availability",
          text: "Add Availability",
          icon: "mdi-clock-outline"
        });
      // }

      return menu;
    }
  },
  methods: {
    ...mapActions(["addSuccessMessage", "addErrorMessage"]),
    changeTeacher() {
      this.$router.replace({
        name: "Teacher",
        params: { id: this.teacher.id }
      });
    },
    pickedColor(val) {
      this.teacher.color = val.hex;
      this.updateTeacherColor();
    },
    initTeacher() {
      const teacherId = this.$route.params.id ? this.$route.params.id : null;
      if (teacherId) {
        this.$axios
          .get("teacher/getById", { params: { teacherId: teacherId } })
          .then(resp => {
            this.teacher = resp.data.data;
            this.teacherLoaded = true;
          });
      }
    },
    deleteRate(rate) {
      console.log(rate.name);
      if (confirm(`Delete rate ${rate.name}?`)) {
        this.$axios
          .post("/teacher/delete-rate", rate)
          .then(() => {
            this.teacher.hourlyRates.splice(
              this.teacher.hourlyRates.findIndex(r => r.id == rate.id),
              1
            );
          })
          .catch(() => {
            this.addErrorMessage("Error deleting rate");
          });
      }
    },
    deleteTeacher() {
      if (
        confirm(
          `Please confirm you want to delete ${this.teacher.firstName}'s account?`
        )
      ) {
        const data = {
          id: this.teacher.id,
          email: this.teacher.email
        };
        this.$axios
          .post("/teacher/delete", data)
          .then(() => {
            this.$router.push({ name: "Teachers" });
          })
          .catch(error => {
            this.addErrorMessage(
              `Error deleting teacher: ${error.data.message || "Unknown"}`
            );
          });
      }
    },
    registerTeacher() {
      const params = { teacherId: this.teacher.id };
      this.$axios
        .post("/teacher/admin/register", null, { params })
        .then(() => {
          // const teacher = resp.data;
          // this.$router.push({name: 'Teacher', params: {id: teacher.id}})
          this.teacher.registered = true;
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });
    },
    updateTeacherColor() {
      if (this.teacher && this.teacher.id) {
        const data = Object.assign({}, this.teacher);

        this.$axios
          .post("/teacher/update", data)
          .then(() => {
            console.log("color upated...");
          })
          .catch(error => {
            this.addErrorMessage(error.message);
          });
      }
    },
    chooseMenu(event, menu) {
      if (menu.id == "switch-teacher") {
        this.teacherDialog = true;
      } else if (menu.id == "add-availability") {
        this.$router.push({
          name: "TeacherAvailability",
          params: { teacherId: this.teacher.id }
        });
      } else if (menu.id == "add-rate") {
        this.$router.push({
          name: "TeacherRate",
          params: { teacherId: this.teacher.id }
        });
      } else if (menu.id == "add-timerecord") {
        this.$router.push({
          name: "TeacherTimeRecord",
          params: { teacherId: this.teacher.id }
        });
      } else if (menu.id == "add-schedule") {
        this.$router.push({
          name: "TeacherSchedule",
          params: { teacherId: this.teacher.id }
        });
      } else if (menu.id == "reset-password") {
        this.resetPwdDialog = true;
      } else if (menu.id == "delete-teacher") {
        this.deleteTeacher();
      }
    }
  },
  mounted() {
    this.tab = this.$route.params.tab ? this.$route.params.tab : "tab-info";
    this.initTeacher();
  },
  components: {
    ChooseTeacher,
    TeacherAvailabilities,
    TeacherCalendar,
    PageHeader,
    TheMask,
    ResetTeacherPassword,
    TeacherAttendance
  }
};
</script>

<style></style>
